<template>
    <div class="modal" v-if="seen">
        <div class="permanent">
            <span>Deleting <strong>{{ str_text(name) }}</strong> permanently</span>
            <br/>
            <span><img src="@/assets/30.gif" /></span>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
    data() {
        return {
            name: '',
            seen: false,
            index: null,
            loader: false,
            error: false,
            id: null,
            found: false,
            src: ''
        }
    },
    methods: {
        ...mapMutations([
            'UPDATE_TOTAL_USED_SPACE',
            'REMOVE_FILE_ACTION'
        ]),
        logincall() {
            this.$parent.logincall()
        },
        str_text(str) {
            return str.length > 22? str.substr(0, 22) + '...' : str
        },
        load(index, id, src) {
            this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
            this.seen = true
            this.index = index
            this.id = id
            this.src = src

            let that = this

            let data = {
                token: cookies.getCookie('token'),
                file_id: this.id,
                delete_type: true
            };

            this.$socket.emit('delete', data, function(data) {
                if(data.message === 'completed') {
                    that.seen = false
                    let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
                    that.UPDATE_TOTAL_USED_SPACE(total_space_used)
                    that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)

                    if(that.src === 'group') {
                        that.REMOVE_FILE_ACTION(that.id);
                    }
                }

                if(data.data === false) {
                    that.seen = false
                    that.logincall()
                    that.$router.push('/login')
                }
            })
        },
        closebox() {
            this.seen = false
        }
    }
}
</script>
